import _pick from 'lodash/pick';

import {
  ERROR_NOTIFICATION_SETTINGS,
  SAVING_NOTIFICATION_SETTINGS,
  SET_SHOW_BLOCKED_NOTIFICATIONS_MODAL,
  SUCCESS_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS,
} from 'constants/actions';
import {
  ALL_COMMENTS_ENABLED,
  ALL_NOTIFICATION_SETTINGS,
  VIDEO_READ,
} from 'constants/notificationSettings';

const DEFAULT_NOTIFICATION_SETTINGS_STATE = {
  settings: {
    [VIDEO_READ]: true,
    [ALL_COMMENTS_ENABLED]: true,
  },
  is_fetching: false,
  success: false,
  error: null,
  showBlockedBanner: false,
};

const notificationSettingsReducer = (
  state = DEFAULT_NOTIFICATION_SETTINGS_STATE,
  action
) => {
  switch (action.type) {
    case SET_SHOW_BLOCKED_NOTIFICATIONS_MODAL:
      return {
        ...state,
        showBlockedBanner: action.showBlockedBanner,
      };

    case UPDATE_NOTIFICATION_SETTINGS:
      return {
        ...state,
        settings: {
          ...state.settings,
          // Remove any notification types that are not listed in ALL
          // Keep in mind this will not add any missing props
          ..._pick(action.notificationSettings, ALL_NOTIFICATION_SETTINGS),
        },
      };
    case SAVING_NOTIFICATION_SETTINGS:
      return {
        ...state,
        is_fetching: true,
        success: false,
      };
    case SUCCESS_NOTIFICATION_SETTINGS:
      return {
        ...state,
        is_fetching: false,
        success: true,
        error: null,
      };
    case ERROR_NOTIFICATION_SETTINGS:
      return {
        ...state,
        is_fetching: false,
        success: false,
        error: action.errorMessage,
      };
    default:
      return state;
  }
};

export default notificationSettingsReducer;
